import { Select, SelectProps } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'

export interface CustomSelectProps extends Omit<SelectProps, 'component'> {
  maxWidth?: string | number
  minWidth?: string | number
}
const CustomSelect: React.FC<CustomSelectProps> = ({
  maxWidth = 180,
  minWidth = 100,
  sx,
  ...props
}) => (
  <Select
    sx={{
      maxWidth,
      minWidth,
      '&:focus': {
        backgroundColor: 'transparent'
      },
      // Apply text overflow to the rendered value element
      '& .MuiSelect-select': {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        // Use paddingRight to ensure space for dropdown icon while allowing full click area
        paddingRight: '32px !important'
      },
      ...((sx as object) || {})
    }}
    {...props}
  />
)

CustomSelect.propTypes = {
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  minWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

export default CustomSelect
